import React, { useEffect } from "react";
import logo from "./logo.svg";
import classes from "./globals/Globals.module.scss";
import "./globals/css_reset.css";
import { ThemeProvider } from "@emotion/react";
import { theme } from "./globals/theme";
import { CssBaseline, IconButton } from "@mui/material";
import Router from "./router/Router";
import Loading from "./components/uikit/Loading";
import { useZoom } from "./hooks/util/useZoom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { useRecoilState } from "recoil";
// import { zoomState } from "./states/zoomState";
function App() {
  useZoom();
  // const [zoom, setZoom] = useRecoilState(zoomState);
  // useEffect(() => {
  //   console.log("zoomLevel", zoom);
  // }, [zoom]);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Loading>
        <Router />
      </Loading>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
    </ThemeProvider>
  );
}

export default App;
